(function () {
    "use strict";

    angular
        .module("app")
        .component("purchaseOrder", { // purchase-order
            bindings: {
                hideReorder: "<"
            },
            templateUrl: "src/app/purchaseOrder/purchaseOrder.html",
            controller: controller
        });

    function controller($window, $routeParams, $location, session, ordersService, toast, reportService) {
        const $ctrl = this;
        $ctrl.session = session;
        $ctrl.orderId = $routeParams.orderId;
        $ctrl.order = null;
		$ctrl.noReorderReasons = [];
        $ctrl.errorOnOrder = null;
        $ctrl.lots = [];
        $ctrl.shippingLabelExists = false;
        $ctrl.shippingLabelDoesNotExist = false;
        $ctrl.clickHereText = "Click here";
        $ctrl.canCreateShippingLabel = true;
        $ctrl.trackingNumber = "";

        $ctrl.$onInit = () => {
            //if (session.user.is_impersonating)
            //    $ctrl.noReorderReasons.push("Cannot reorder while impersonating."); // This requirement was removed.

			session.cart
				.getPurchaseOrder($routeParams.orderId)
                .then(loadOrder)
				.catch((err) => {
					$ctrl.errorOnOrder = err.data;
				});
				
        };

        $ctrl.createShippingLabel = () => {
            $ctrl.canCreateShippingLabel = false;
            $ctrl.clickHereText = "Creating...";

            ordersService.getShippingLabel($ctrl.orderId).then(result => {
                $ctrl.trackingNumber = result.data.TrackingNumber;
                $ctrl.shippingLabelDoesNotExist = false;
                $ctrl.shippingLabelExists = true;
            });
        };

        function mergeUnique(arr1, arr2) {
            const items = [];
            arr1.forEach(v => items.push(v));
            arr2.forEach(v => {
                const existing = items.find(i => i.lot_no === v.lot_no);
                if (!existing)
                    items.push(v);
                else {
                    if (!existing.has_CoA)
                        existing.has_CoA = v.has_CoA; // overwrite false with true if any of the lots return true.
                }
            });
            return items;
        }

        function shipmentLots(shipment) {
            return shipment.lines.reduce((prev, line) => {
                if (line.lot_no)
                    return mergeUnique(prev, [
                        {
                            lot_no: line.lot_no,
                            has_CoA: line.has_CoA
                        }]);
                else
                    return prev;
            }, []);
        }

        function orderLots(order) {
            return order.shipments.reduce((prev, shipment) => {
                return mergeUnique(prev, shipmentLots(shipment));
            }, []);
        }

        function itemTotal(item) {
            return item.quantity * item.price_per;
        }

        function itemDiscountTotal(item) {
            return item.display_in_line_item_level_bit ? (item.full_price - item.price_per) * item.quantity : 0;
        }

        function itemBonusDiscountTotal(item) {
            return !item.display_in_line_item_level_bit ? (item.full_price - item.price_per) * item.quantity : 0;
        }

        function surchargeTotal(item) {
            const kitCheck = item.kit_check_surcharge == null ? 0 : item.kit_check_surcharge;
            return item.quantity * kitCheck;
        }

        function loadOrder(order) {
            if (!order.shipping_charges)
                order.shipping_charges = 0;

            $ctrl.order = order;

            if (order.customer_id !== session.customer.customer_id)
                $ctrl.noReorderReasons.push(`Order for ${order.company_name}`);

            const reorderItemCount = getReorderItemCount(order);

            if (session.cart.itemCount + reorderItemCount > session.cart.maxItemCount)
                $ctrl.noReorderReasons.push("Cart does not have enough room for all reorder items.");

            if (!order.lines.some(l => l.can_reorder))
                $ctrl.noReorderReasons.push("None of the items are able to be ordered.");

            order.itemDiscountSubTotal = order.lines.reduce((prev, item) => prev + itemDiscountTotal(item), 0);
            order.itemBonusDiscountSubTotal = order.lines.reduce((prev, item) => prev + itemBonusDiscountTotal(item), 0);
            order.itemSubTotal = order.lines.reduce((prev, item) => prev + itemTotal(item), 0);
            order.surchargeSubTotal = order.lines.reduce((prev, item) => prev + surchargeTotal(item), 0);
            order.origSubTotal = order.itemSubTotal + order.itemDiscountSubTotal + order.itemBonusDiscountSubTotal;
            order.subTotal = order.itemSubTotal + order.surchargeSubTotal;


            if (order.shipments) 
                $ctrl.lots = orderLots(order).sort(sortLots);

            if ($ctrl.order.is_form222) {
                return ordersService.shippingLabelExists($ctrl.orderId).then(result => {
                    if (result.data.exists) {
                        return ordersService.getShippingLabel($ctrl.orderId).then(result2 => {
                            $ctrl.trackingNumber = result2.data.TrackingNumber;
                            $ctrl.shippingLabelBytes = `data:image/gif;base64,${result2.data.Bytes}`;
                            $ctrl.shippingLabelExists = true;
                        });

                    } else
                        $ctrl.shippingLabelDoesNotExist = true;
                    return order;
                });
            } else {
                return order;
            }
        }

        $ctrl.canReorder = () => {
            return $ctrl.noReorderReasons.length === 0;
        };

        $ctrl.orderAgainClicked = () => {
            ordersService.orderAgain($ctrl.orderId)
                .then(session.cart.refresh)
                .then(() => {
                    //$window.ga("send", "event", "Reorder", "orderAgainClicked");
                    $location.path(`/checkout/${$ctrl.orderId}`);
                })
                .catch(toast.errorHandler);
        };

        function getReorderItemCount(order) {
            return $ctrl.order.lines.reduce((prev, value) => {
                if (value.can_reorder)
                    prev = prev + value.quantity;
                return prev;
            }, 0);
        }

        $ctrl.certOfAnalClicked = lot => {
            //$window.ga("send", "event", "CertOfAnalysis", "certOfAnalysisFromPOClicked");
            if (lot.has_CoA)
                reportService.getCertificateOfAnalysisRpt(lot.lot_no);
            else
                $location.path("/contact");

        };

        $ctrl.printE222Form =() => {
            //$window.ga("send", "event", "e222Form", "e222FormClicked");

            reportService.getE222Form($ctrl.orderId);
        };

        function sortLots(a, b) {
            if (a.lot_no < b.lot_no)
                return -1;
            if (a.lot_no > b.lot_no)
                return 1;
            return 0;
        }
    }
    controller.$inject = ["$window", "$routeParams", "$location", "sessionService", "ordersService", "stToastFactory", "reportService"];

})()